import React, {useCallback, useEffect, useState} from 'react';
import {Toggle} from '@src/components/shared/toggle/toggle';
import mlRecommendationService from '@src/services/ml-recommendation.service';
import {useStores} from '@src/components/store';
import './policy-recommendations-tab.scss';
import PolicyRecommendations from '../../../../assets/svg/policy-recommendations.svg?react';
import Loader from '@src/components/shared/loader/loader';

const PolicyRecommendationsTab: React.FC = () => {
    const { customerStore, userStore } = useStores();
    const [policyRecommendationState, setPolicyRecommendationState] = useState<undefined | boolean>(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (policyRecommendationState === undefined) {
            const getMlState = async () => {
                try {
                    setLoading(true);
                    const state = await mlRecommendationService.getMlState(customerStore.customerId);
                    setPolicyRecommendationState(state);
                } catch (err) {
                    console.error('Failed to Get ML state: ', err);
                } finally {
                    setLoading(false);
                }
            };
            void getMlState();
        }
    }, [customerStore.customerId, policyRecommendationState]);

    const handlePolicyRecommendationStateChange = useCallback((newState: boolean) => {
        const setMlState = async () => {
            try {
                setLoading(true);
                const state = await mlRecommendationService.setMlState(customerStore.customerId, newState);
                setPolicyRecommendationState(state);
            } catch (err) {
                console.error('Failed to Set ML state: ', err);
            } finally {
                setLoading(false);
            }
        };
        void setMlState();
    }, [customerStore.customerId]);

    return (
        <div className="policy-tab">
            <div className="policy-tab-logo"><PolicyRecommendations/></div>
            <div className="policy-tab-content-group">
                <div className="policy-tab-description-group">
                    <div className="tab-title">AI-powered policy recommendations</div>
                    <div className="tab-description">
                        Get monthly policy recommendations to block Apps and IPs and enhance your business protection.
                    </div>
                </div>
                <div className={`policy-recommendation-toggle`}>
                    <Toggle
                        label={policyRecommendationState ? 'ON' : 'OFF'}
                        onChange={handlePolicyRecommendationStateChange}
                        value={!!policyRecommendationState}
                        disabled={policyRecommendationState === undefined || loading || userStore.isReadOnlyUser }
                    />
                </div>
            </div>
            {loading && <Loader type={'full-screen'}/>}
        </div>
    );
};

export default PolicyRecommendationsTab;